// Import ACF Blocks JavaScript
import './js/blocks.js';

jQuery(function($) {

    // // Pretty dropdowns
    // $('select').prettyDropdown({
    //     height: 48
    // });

    // Wrap table to div
    $('table').wrap('<div class="table-responsive"></div>');
    
    $(window).on('scroll', function() {
        if ($(this).scrollTop() > 1) {
            $('#header').addClass('scrolled');
        } else {
            $('#header').removeClass('scrolled');
        }
    });

});
